interface SocialLinksProps {
  className?: string
}

export default function SocialLinks({ className = '' }: SocialLinksProps) {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {/* Twitter/X Link */}
      <a
        href="https://twitter.com/rugscanme"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow RugScan on Twitter"
        className="group flex items-center gap-2 text-muted hover:text-white transition-colors duration-200"
      >
        <span className="p-2 rounded-lg bg-surface border border-surface-border group-hover:border-primary/50 group-hover:bg-surface-hover transition-all duration-200">
          {/* X (Twitter) Icon */}
          <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-5 h-5"
            aria-hidden="true"
          >
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
        </span>
        <span className="text-sm font-medium">@rugscanme</span>
      </a>
    </div>
  )
}
